<template>
  <div v-if="!allStepsCompleted" class="marketplace_registration_header">
    <div class="header_navigation_wrapper desk_navigation">
      <ul>
        <li
          v-for="(step, stepIndex) in steps"
          :key="stepIndex"
          :class="{
            active_step: step.isActive,
            [`step_${stepIndex + 1}`]: true,
          }"
        >
          <a
            class="navigation_link"
            href="#"
            :class="{ active_step: step.isActive }"
            @click.prevent=""
          >
            <span>
              {{ stepIndex + 1 }}. {{ step.title }}
              <span v-if="step.isCompleted" class="ok"></span>
            </span>
          </a>
        </li>
      </ul>
    </div>
    <div class="header_navigation_wrapper mobile_navigation">
      <ul>
        <li
          v-for="(step, stepIndex) in steps"
          :key="stepIndex"
          :class="{
            active_step: step.isActive,
            [`step_${stepIndex + 1}`]: true,
          }"
        >
          <router-link
            :to="{ name: 'home' }"
            class="mobile_back_btn"
          ></router-link>
          <span class="navigation_link">
            <span> {{ stepIndex + 1 }}. {{ step.title }} </span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationsSupplierNavigation',
  computed: {
    steps() {
      return this.$store.getters['supplier/getSteps'];
    },
    allStepsCompleted() {
      return this.$store.getters['supplier/getAllStepsCompleted'];
    },
  },
};
</script>
